import Flickity from 'flickity'

import { on, get, getAll } from '@bigyouth/base'

// import withResponsive from '../hoc/withResponsive'
import scrollManager from '../utils/scrollManager'
import pressedKey from '../utils/pressedKey'

export default {
  name: 'product-gallery',

  isModalOpen: false,
  isMobile: window.innerWidth < 1024,

  ui: {
    // Regular Slider
    slider: '[js-product-gallery-slider]',
    'slides[]': '[js-product-gallery-slide]',
  },

  events: [
    {
      target: 'slides',
      on: 'click',
      handle (elt) {
        const index = this.ui.slides.indexOf(elt.currentTarget)
        if (!this.isMobile) this.handleClick(index)
      },
    },
  ],

  componentDidMount () {
    // Move slider to modals layer
    window.addEventListener('resize', () => {
      const oldIsMobile = this.isMobile
      this.isMobile = window.innerWidth < 1024

      if (this.isMobile !== oldIsMobile) {
        if (this.flickity) this.flickity.destroy()
        this.initRegularFlickity()
      }
    })

    const modalsLayer = get('.modals')
    this.modal = get('[js-product-modal-gallery]')

    modalsLayer.appendChild(this.modal)

    this.initRegularFlickity()
    this.initModalFlickity()

    on('keyup', event => {
      if (this.isModalOpen) {
        if (pressedKey('right')(event)) {
          this.modalFlickity.next()
        } else if (pressedKey('left')(event)) {
          this.modalFlickity.previous()
        }
      }
    })(document.body)
  },

  initRegularFlickity () {
    const mobileOptions = {
      friction: 0.15,
      selectedAttraction: 0.0075,
      pageDots: false,
      cellAlign: window.innerWidth >= 768 ? 0 : 0.35,
      lazyLoad: 2,
      prevNextButtons: false,
    }

    const desktopOptions = {
      pageDots: true,
    }

    const options = (this.isMobile) ? mobileOptions : desktopOptions

    this.flickity = new Flickity(this.ui.slider, options)

    this.flickity.on('staticClick', (event, pointer, cellElement, cellIndex) => {
      this.handleClick(cellIndex)
    })
  },

  handleClick (index) {
    this.modalFlickity.select(index, false, true)

    this.modal.classList.remove('is-hidden')
    this.isModalOpen = true

    setTimeout(function () {
      scrollManager.stop()
    }, 500)
  },

  initModalFlickity () {
    const modalSlider = get('[js-product-modal-gallery-slider]')
    this.modalPictures = getAll('[js-product-modal-gallery-picture]')
    const modalClose = get('[js-product-modal-gallery-close]')
    const modalPrev = get('[js-product-modal-gallery-prev]')
    const modalNext = get('[js-product-modal-gallery-next]')

    this.modalFlickity = new Flickity(modalSlider, {
      pageDots: false,
      lazyLoad: 1,
      prevNextButtons: false,
      wrapAround: true,
    })

    // MODAL CLOSE BUTTON
    modalClose.addEventListener('click', () => {
      scrollManager.restart()
      this.modal.classList.add('is-hidden')
      this.isModalOpen = false
    })

    // MODAL NAV BUTTONS
    modalPrev.addEventListener('click', () => {
      this.modalFlickity.previous()
    })
    modalNext.addEventListener('click', () => {
      this.modalFlickity.next()
    })

    if (!this.isMobile) {
      modalSlider.addEventListener('click', (e) => {
        scrollManager.restart()
        this.modal.classList.add('is-hidden')
        this.isModalOpen = false
      })
    }
  },
}
